import { render, staticRenderFns } from "./InvestmentSummaryParagraph.vue?vue&type=template&id=31b65958&scoped=true&"
import script from "./InvestmentSummaryParagraph.vue?vue&type=script&setup=true&lang=js&"
export * from "./InvestmentSummaryParagraph.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./InvestmentSummaryParagraph.vue?vue&type=style&index=0&id=31b65958&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b65958",
  null
  
)

export default component.exports